import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { TrainingService } from "./training.service";
import *  as $ from 'jquery';
import { DATOS_API } from 'app/auth/auth.datos';
import * as backInter from 'app/auth/auth-data.model';
import { fuseAnimations } from '@fuse/animations';
import { lang_wizard } from 'app/idiomas/i18n/wizard/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss'],
  animations : fuseAnimations
})
export class TrainingComponent implements OnInit {

  idiomaActual:string;
  mailUsuario: string;
  // urlCA = '//gptw-learning.com/centroamerica/autologueo.php?usr=';
  urlCA = '//gptw-learning.com/centroamerica?CGO5_user=';
  urlCA_en = '//gptw-learning.com/eng-centroamerica?CGO5_user=';
  urlSafe: SafeResourceUrl;
  urlEncontrada: boolean;
  urlElegida: string;
  htp = DATOS_API.url.split("/");

  constructor(
    public authService: AuthService,
    public sanitizer: DomSanitizer,
    private translateSrv: TranslateService,
    private ca_tr_Service: TrainingService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    //al cambiar el idioma, se cambia el valor de las variables de idiomas que se usan dentro del codigo
    this.translateSrv.onLangChange.subscribe(() => { this.traduceTextosTS(); });
    lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    this.traduceTextosTS();
  }

  traduceTextosTS(){
    switch(this.translateSrv.currentLang){
      case 'es': this.urlElegida = this.urlCA; break;
      default: this.urlElegida = this.urlCA_en;
    }
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    console.log(infoUsu);
    this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.htp[0] + this.urlElegida + infoUsu.user);
  }

}
